// Legacy JavaScript and CSS imports migrated from Sprockets

// Import legacy styles
import "../stylesheets/legacy.scss";

// Import jQuery and make it globally available
import $ from "jquery";
window.$ = window.jQuery = $;

// Import and expose Cookies and jstz globally for legacy scripts
import Cookies from "js-cookie";
window.Cookies = Cookies;

import jstz from "jstimezonedetect";
window.jstz = jstz;

// NOTE: @rails/ujs removed — Turbo (via @hotwired/turbo-rails in application.js) handles
// form submissions and link behavior. Loading both causes "rails-ujs has already been loaded!" errors.
// Instead, we manually set up CSRF token injection for jQuery AJAX requests.
$.ajaxSetup({
  beforeSend: function(xhr) {
    var token = document.querySelector('meta[name="csrf-token"]');
    if (token) xhr.setRequestHeader('X-CSRF-Token', token.getAttribute('content'));
  }
});

// Polyfill for data-remote="true" forms (previously handled by @rails/ujs).
// This intercepts form submissions with data-remote="true" and sends them via AJAX,
// then evaluates the JS response (for .js.erb templates).
$(document).on('submit', 'form[data-remote="true"]', function(e) {
  e.preventDefault();
  var $form = $(this);
  var method = ($form.find('input[name="_method"]').val() || $form.attr('method') || 'POST').toUpperCase();
  var url = $form.attr('action');
  var formData = new FormData(this);

  $.ajax({
    url: url,
    type: method,
    data: formData,
    processData: false,
    contentType: false,
    dataType: 'script',
    success: function(response) {
      // jQuery dataType:'script' auto-evaluates the JS response
    },
    error: function(xhr) {
      console.error('Remote form submission failed:', xhr.status, xhr.statusText);
    }
  });
});

// Import vendor jQuery plugins
import "../../../vendor/assets/javascripts/jquery-readyselector.js";

import "datatables.net";
import "datatables.net-responsive";
import "jquery-timepicker/jquery.timepicker.js";
import "jquery-ui-dist/jquery-ui";
import "jquery-minicolors";
import "select2";
import "flatpickr";
// Import all legacy modules - this executes them
const legacyContext = require.context("../../assets/javascripts/legacy", true, /\.js$/);
legacyContext.keys().forEach(legacyContext);

// Enable Turbo Drive only for main/admins controllers (except user_switching, unless it's list)
const enableTurboForAdmins = () => {
  // const controllerName = document.body.dataset.controller;
  // const isAdminController = controllerName && controllerName.startsWith('futurelab/main/admins/');

  // // Alternative check using URL path if data-controller is not available
  // const isAdminPath = window.location.pathname.includes('/main/admins/');

  // // Exclude user_switching as it can cause problems (but allow list page)
  // const isUserSwitching = controllerName?.includes('user_switching') || 
  //                         window.location.pathname.includes('/main/admins/user_switching');
  // const isUserSwitchingList = window.location.pathname.includes('/main/admins/user_switching/list');

  // if ((isAdminController || isAdminPath) && (!isUserSwitching || isUserSwitchingList)) {
  //   Turbo.session.drive = true;
  // } else {
  Turbo.session.drive = false;
  // }
}

// Run on initial load
enableTurboForAdmins();

// Portal Overview Agenda Tabs
$(document).on('click', '#nav-tab [data-bs-toggle="tab"]', function(e) {
  e.preventDefault();
  var target = $(this).attr('href');

  // Update tab appearance within nav-tab only
  $('#nav-tab [data-bs-toggle="tab"]')
    .removeClass('tw-border-blue-500 tw-text-blue-600 tw-bg-blue-50')
    .addClass('tw-text-gray-600 tw-border-transparent');
  $(this)
    .removeClass('tw-text-gray-600 tw-border-transparent')
    .addClass('tw-border-blue-500 tw-text-blue-600 tw-bg-blue-50');

  // Show/hide content within nav-tabContent only
  $('#nav-tabContent .tab-pane').removeClass('show active');
  $(target).addClass('show active');
});

// Text truncation with "Show more" functionality
function truncateMoreText() {
  var showChar = 500;
  var ellipsestext = "...";
  var moretext = "Show more";

  $('.more').each(function() {
    var content = $(this).html().trim();

    if (content.length > showChar && !$(this).data("truncated")) {
      var visible = content.substring(0, showChar);
      var hidden = content.substring(showChar);

      var html =
        visible +
        '<span class="more-ellipses">' + ellipsestext + '</span>' +
        '<span class="more-content" style="display:none;">' + hidden + '</span>' +
        ' <a href="#" class="morelink">' + moretext + '</a>';

      $(this).html(html).data("truncated", true);
    }
  });
}

$(document).on('ready turbo:load page:load DOMContentLoaded', function() {
  truncateMoreText();
});

$(document).on('click', '.morelink', function(e) {
  e.preventDefault();

  var $link = $(this);
  var $parent = $link.closest('.more');
  var $content = $parent.find('.more-content');
  var $ellipses = $parent.find('.more-ellipses');

  $content.toggle();
  $ellipses.toggle();

  $link.text($link.text() === "Show more" ? "Show less" : "Show more");
});

// Progress bar animation
$(document).on('ready turbo:load page:load DOMContentLoaded', function() {
  $(".progress").each(function() {
    var value = $(this).attr('data-value');
    var left = $(this).find('.progress-left .progress-bar');
    var right = $(this).find('.progress-right .progress-bar');
    if (value > 0) {
      if (value <= 50) {
        right.css('transform', 'rotate(' + (value / 100 * 360) + 'deg)');
      } else {
        right.css('transform', 'rotate(180deg)');
        left.css('transform', 'rotate(' + ((value - 50) / 100 * 360) + 'deg)');
      }
    }
  });
});

// Generic page view tracking for legacy (non-React) pages.
// Fires on every Turbo navigation. React pages with their own useTrackPageView
// will fire a more specific event; this provides baseline coverage for all others.
$(document).on('turbo:load', function() {
  if (window.mixpanel && typeof window.mixpanel.track === 'function') {
    window.mixpanel.track('page_viewed', {
      path: window.location.pathname,
      title: document.title,
      referrer: document.referrer || null
    });
  }
});
